import { useApiClient } from "@/hooks/useApiClient";
import useSWRImmutable from "swr/immutable";

interface AnalyzeAmountResponse {
  price: number;
}

interface IResponse {
  data: AnalyzeAmountResponse | null;
  isLoading: boolean;
}

const endpointUrls = {
  "all-matters": "all-matters-analyze/amount",
  owner: "owner-analyze/amount",
  "commercial-picture": "commercial-picture-analyze/amount",
};

export type AnalyzeType = keyof typeof endpointUrls;

export const useAnalyzeAmount = (type: AnalyzeType): IResponse => {
  const { apiClient } = useApiClient();

  const fetcher = async (url: string): Promise<AnalyzeAmountResponse> => {
    const { data } = await apiClient.get<AnalyzeAmountResponse>(url);
    return data;
  };

  const { data, isLoading } = useSWRImmutable(endpointUrls[type], fetcher);

  return { data: data ?? null, isLoading };
};
